<template>
  <b-container>
    <div class="py-5 text-left">
      <h1> Account Confirmation </h1>
      <div v-if="status=='success'">
        <h5 class="mb-4">Thank you for confirming your account. Please follow the link below to login:</h5>
        <b-button to="/login">Login here</b-button> 
      </div>
      <div v-if="status=='nouser'">
        <h5 class="mb-4">The email address is not registered on our site. Please follow the link below to register:</h5>
        <b-button to="/register">Register here</b-button> 
      </div>
      <div v-if="status=='alreadyconfirmed'">
        <h5 class="mb-4">You already confirmed your account before. Please follow the link below to login:</h5>
        <b-button to="/login">Login here</b-button> 
      </div>
      <div v-if="status=='invalidtoken'">
        <h5 class="mb-4">The confirmation token is invalid. Please follow the link below to register:</h5>
        <b-button to="/register">Register here</b-button> 
      </div>
    </div>
  </b-container>
</template>

<script>

export default {
  name: 'confirm',

  computed: {
    status () {
      return this.$route.params.status
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
